/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_NEXTGEN_BOARD = 'NEXTGEN_BOARD';
export const RESOURCE_TYPE_NEXTGEN_BOARD_CUSTOM_FILTERS = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
export const RESOURCE_TYPE_NEXTGEN_BOARD_RELAY = 'NEXTGEN_BOARD_RELAY';
export const RESOURCE_TYPE_NEXTGEN_BOARD_FILTER_REFINEMENT = 'NEXTGEN_BOARD_FILTER_REFINEMENT';
export const RESOURCE_TYPE_NEXTGEN_BOARD_TMP_MATURE_EXAMPLE_GUPS =
	'NEXTGEN_BOARD_TMP_MATURE_EXAMPLE_GUPS';
